import { removeWhitespaces } from '@/shared/utils/string';

type IbanListLine = {
  accountNumber?: string | null;
  isDefault?: boolean;
};

type IbanList = readonly (IbanListLine | undefined)[] | undefined;

const normalizeAccountNumber = (accountNumber: string) =>
  removeWhitespaces(accountNumber).toLowerCase();

const countDefaults = (ibans: IbanList) => ibans?.filter((iban) => iban?.isDefault).length ?? 0;

const hasDefaultIban = (ibans: IbanList) => !ibans?.length || countDefaults(ibans) >= 1;

const hasAtMostOneDefaultIban = (ibans: IbanList) => countDefaults(ibans) <= 1;

const hasNoDuplicateIbans = (ibans: IbanList) => {
  const accountNumbers = (ibans ?? [])
    .map((iban) => normalizeAccountNumber(iban?.accountNumber ?? ''))
    .filter(Boolean);

  return new Set(accountNumbers).size === accountNumbers.length;
};

export { hasAtMostOneDefaultIban, hasDefaultIban, hasNoDuplicateIbans };
